var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NationalSystem',{attrs:{"title":"CYPRIS","filter":r => r.notebook === 'CYPRIS',"scan-results":_vm.scanResults}},[_vm._v(" CYPRIS sends a single extract for the whole of Wales each day. This file was not received (so far) on this day. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }